import { api } from "api/api";
import { AxiosError } from "axios";
import ClassificacaoFiscal from "model/fiscal/ClassificacaoFiscal";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ClassificacaoFiscalService implements BaseServiceCadastros<ClassificacaoFiscal> {

    getAll() {
        return new Promise<ClassificacaoFiscal[]>((resolve, reject): void => {
            api
                .get(`/classificacaoFiscal/getAll`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/classificacaoFiscal/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ClassificacaoFiscal>((resolve, reject): void => {
            api
                .get(`/classificacaoFiscal/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(classificacaoFiscal: ClassificacaoFiscal) {
        return new Promise<ClassificacaoFiscal>((resolve, reject): void => {
            api
                .post(`/classificacaoFiscal/incluir`, JSON.stringify(classificacaoFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(classificacaoFiscal: ClassificacaoFiscal) {
        return new Promise<ClassificacaoFiscal>((resolve, reject): void => {
            api
                .put(`/classificacaoFiscal/editar`, JSON.stringify(classificacaoFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/classificacaoFiscal/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}
export default ClassificacaoFiscalService;
